import {
  RevenueCatData,
  StoreType,
} from '../../florence/types/RevenueCatTypes';
import { SubscriptionType } from '../../florence/types/SubscriptionType';

import { Organization } from './Organization';

export enum UserRoles {
  SUPER_ADMIN = 'super_admin',
  ORG_OWNER = 'org_owner',
  CODER = 'coder', // coder within an organization
  USER = 'user', // individual user or member within an organization
}

export type QuickUser = {
  id: number;
  fullName: string;
  email: string;
  organizationId: number;
  accessRoles: Array<UserRoles>;
};

export type CreateUserPayload = {
  email: string;
  fullName: string;
  role: UserRoles;
  organizationId?: number;
  speciality?: string;
  phone?: string;
  password?: string;
};

export type CreateUserResponse = {
  message: string;
  user: {
    id: number;
    email: string;
    fullName: string;
    accessRoles: Array<UserRoles>;
    organizationId: number | null;
  };
  password: string;
};

export type User = {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phone: string;
  keywordSearchesUsed: number;
  scanSearchesUsed: number;
  subscription: string;
  lastLogin: string;
  accessRoles: Array<UserRoles>;
  role: string;
  practiceName: string;
  speciality: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  lastKnownSubscription?: 'trial' | 'mobile' | 'desktop' | 'enterprise' | null;
  subscriptionPurchaseDate: Date | null;
  subscriptionExpirationDate: Date | null;
  subscriptionStore: StoreType;
  activeSubscriptionType: undefined;
  purchasedScansAvailable: number;
  overwriteSubscription: null | 'trial' | 'mobile' | 'desktop';
  organizationId: number | null;
  organizationName: string | null;
  athenaUsername: string | null;
};

export type CurrentUser = {
  id: number;
  fullName: string;
  phone: string;
  email: string;
  practiceName: string;
  role: string;
  speciality: string;
  active: boolean;
  isTrial: boolean;
  isViewedWelcomeNote: boolean;
  purchasedScansAvailable: number;
  trialScansAvailable: number;
  activeSubscriptionType: SubscriptionType;
  revenueCatData: RevenueCatData | null;
  subscriptionPurchaseDate: Date | null;
  subscriptionExpirationDate: Date | null;
  subscriptionStore: StoreType;
  createdAt: Date;
  updatedAt: Date;
  accessRoles: Array<UserRoles>;
  idToken: string;
  state: string;
  organizationId: null | number;
  organization: null | Organization;
};
